import type { SVGProps } from 'react';
export const SvgView = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={21}
		fill="none"
		viewBox="0 0 20 21"
		{...props}
	>
		<path
			fill="#101010"
			fillRule="evenodd"
			d="M2.574 10.5a7.837 7.837 0 0 0 14.852 0 7.837 7.837 0 0 0-14.852 0m-1.002-.15a8.837 8.837 0 0 1 16.857 0 .5.5 0 0 1 0 .3 8.837 8.837 0 0 1-16.857 0 .5.5 0 0 1 0-.3M10 8.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3 2a3 3 0 1 1 6 0 3 3 0 0 1-6 0"
			clipRule="evenodd"
		/>
	</svg>
);
